import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <div>
         <h1>Oops!</h1>
         <p>Sorry, an unexpected error has occurred.</p>
         {error && (
            <p style={{ color: '#888', marginTop: 10 }}>
               <i>{error.statusText || error.message || String(error)}</i>
            </p>
         )}
      </div>
    </div>
  );
}
